"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedControlGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledSegmentedControlGroup = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    width: "fit-content",
    "& > *:first-child": {
        borderColor: stitches_config_1.theme.colors.gray7,
        borderLeftWidth: "1px",
        borderTopLeftRadius: stitches_config_1.theme.shape.borderRadius,
        borderBottomLeftRadius: stitches_config_1.theme.shape.borderRadius,
        borderLeftStyle: "solid",
    },
    "& > *:last-child": {
        borderColor: stitches_config_1.theme.colors.gray7,
        borderRightWidth: "1px",
        borderTopRightRadius: stitches_config_1.theme.shape.borderRadius,
        borderBottomRightRadius: stitches_config_1.theme.shape.borderRadius,
        borderRightStyle: "solid",
    },
});
var StyledSegmentedControlItem = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderWidth: "1px 1px 1px 0px",
    borderStyle: "solid",
    cursor: "pointer",
    borderColor: stitches_config_1.theme.colors.gray7,
    padding: "8px 12px",
    background: stitches_config_1.theme.colors.gray2,
    gap: "6px",
    "&:hover": {
        background: stitches_config_1.theme.colors.white,
    },
    variants: {
        active: {
            true: {
                background: stitches_config_1.theme.colors.white,
            },
        },
    },
});
var IconWrapper = (0, stitches_config_1.styled)("div", {
    color: stitches_config_1.theme.colors.gray11,
    height: "15px",
    variants: {
        active: {
            true: {
                color: stitches_config_1.theme.colors.gray12,
            },
        },
    },
});
function SegmentedControlItem(props) {
    return ((0, jsx_runtime_1.jsxs)(StyledSegmentedControlItem, __assign({ onClick: props.onClick, active: props.active }, { children: [props.icon && ((0, jsx_runtime_1.jsx)(IconWrapper, __assign({ active: props.active }, { children: props.icon }))), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.label }))] })));
}
function SegmentedControlGroup(props) {
    return ((0, jsx_runtime_1.jsx)(StyledSegmentedControlGroup, { children: props.options.map(function (option) {
            return ((0, jsx_runtime_1.jsx)(SegmentedControlItem, { active: props.value === option.value, label: option.label, icon: option.icon, onClick: function () {
                    props.onChange(option.value);
                } }, option.value));
        }) }));
}
exports.SegmentedControlGroup = SegmentedControlGroup;
//# sourceMappingURL=SegmentedControlGroup.js.map